import classNames from "classnames";
import { Text } from "@components/Text";
import { FavoriteItemTypeEnum } from "@graphql/__generated__/types";
import type { UseCommonData_SportGenreFragment } from "@hooks/useCommonData/__generated__/fragments";
import { IFImg } from "@libs/utils/IFImg";
import styles from "./index.module.css";
import type { FC } from "react";

type FavoriteTeamModalSportIconProps = {
  sport: UseCommonData_SportGenreFragment;
  selectionIndex: number;
  onClick: (type: FavoriteItemTypeEnum, id: number) => void;
};

export const FavoriteTeamModalSportIcon: FC<
  FavoriteTeamModalSportIconProps
> = ({ sport, selectionIndex, onClick }) => {
  const isSelected = selectionIndex >= 0;
  return (
    <div
      className={classNames(
        styles.favoriteTeamListItem,
        isSelected ? styles.selected : null
      )}
      onClick={() => onClick(FavoriteItemTypeEnum.SportGenre, sport.id)}
    >
      <div className={classNames(styles.favoriteTeamLogo, styles.sportLogo)}>
        {sport.iconPath ? (
          <img src={IFImg(sport.iconPath)} alt="" />
        ) : (
          <Text size={12} className={styles.sportLogoText}>
            {sport.name}
          </Text>
        )}
        {isSelected && (
          <i className={styles.favoriteTeamSelected}>{selectionIndex + 1}</i>
        )}
      </div>
      <Text size={12} className={styles.favoriteTeamListItemText}>
        {sport.name}
      </Text>
    </div>
  );
};
